import React from "react"

import { Title } from "../styles"
import { Wrapper, Details, Item, Heading, Image, Text, LinkText } from "./styles"

const RecipeIngredients = ({ ingredients }) => {
  const imageSizes = {
    1024: [671, 99999],
    768: [472, 99999],
    0: [671, 99999],
  }

  return (
    <Wrapper>
      <Title>{ingredients.title}</Title>
      <Details>
        {ingredients.items.map((item) => (
          <Item key={item.ingredient}>
            {item.image ? (
              <Image
                fetchpriority="low"
                imageData={item.image}
                sizes={[
                  {
                    query: 1024,
                    width: imageSizes[1024][0],
                    height: imageSizes[1024][1],
                    transforms: `c_scale,w_${imageSizes[1024][0]},q_auto,f_auto,fl_lossy`,
                  },
                  {
                    query: 768,
                    width: imageSizes[768][0],
                    height: imageSizes[768][1],
                    transforms: `c_scale,w_${imageSizes[768][0]},q_auto,f_auto,fl_lossy`,
                  },
                  {
                    width: imageSizes[0][0],
                    height: imageSizes[0][1],
                    transforms: `c_scale,w_${imageSizes[0][0]},q_auto,f_auto,fl_lossy`,
                  },
                ]}
                alt={item.image.altText}
                contain
              />
            ) : (
              <Heading>{item.ingredient}</Heading>
            )}
            {item.url ? (
              <a href={item.url} target="_blank" rel="noreferrer">
                <LinkText>
                  {item.quantity} {item.unit}{" "}
                  {item.description ? item.description : item.ingredient}
                </LinkText>
              </a>
            ) : (
              <Text>
                {item.quantity} {item.unit} {item.description ? item.description : item.ingredient}
              </Text>
            )}
          </Item>
        ))}
      </Details>
    </Wrapper>
  )
}

export default RecipeIngredients
